export type SEVERITY = 'ERROR' | 'WARN' | 'INFO';

export const SEVERITY_INFO = 'INFO';
export const SEVERITY_WARN = 'WARN';
export const SEVERITY_ERROR = 'ERROR';
